import { render } from "./ChartOrderByOrderStatus.vue?vue&type=template&id=5855955c"
import script from "./ChartOrderByOrderStatus.vue?vue&type=script&lang=js"
export * from "./ChartOrderByOrderStatus.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\DELL\\source\\repos\\project0810frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])